namespace SPA
{
	export namespace Organization
	{
		export namespace gui
		{
			export class DepartmentEntry extends AbstractEntry
			{

				private m_Department: Wollmilch.DepartmentObject;

				public constructor( obj: Wollmilch.DepartmentObject, orga: OrgaTree )
				{
					super( orga );

					this.m_Department = obj;

					this.clearTitle();
				}

				public rebuild( root?: ui.base.BaseHTMLElement<HTMLElement> | JQuery<HTMLElement> ): DepartmentEntry
				{
					super.rebuild( root );

					this.buildBasicInfo();
					new SPA.gui.view.AccountView( this.m_Department ).rebuild( this );

					return this;
				}

				private buildBasicInfo()
				{
					ui.$$.div()
						.appendTo(this.Root())
						.append('<h2>Organisation - Abteilung</h2>')
						.append(
							new SPA.gui.address.AddressSection( this.m_Department, this.m_Orga ).rebuild().Root()
						);
				}
			}
		}
	}
}
